import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import firebase from "firebase";
import  Quasar from './quasar'
import Vuelidate from "vuelidate"
import { VueMaskDirective } from 'v-mask'
import Loader from "./components/Loader"
import VueApexCharts from 'vue-apexcharts'
import './globalComponents'
import currencyFilter from "./filters/currency.filter"
import btcFilter from "./filters/btc.filter"


Vue.component('apexchart', VueApexCharts)
Vue.component('Loader', Loader)

Vue.filter('currency', currencyFilter)
Vue.filter('btc', btcFilter)
Vue.directive('mask', VueMaskDirective);
Vue.use(Vuelidate);
export const eventEmitter = new Vue();

Vue.config.productionTip = true

const firebaseConfig = {
  apiKey: "AIzaSyCsG1G0vWt5sJaMBfKF3b79eZUAjQj37B8",
  authDomain: "profit-manager-5f875.firebaseapp.com",
  databaseURL: "https://profit-manager-5f875.firebaseio.com",
  projectId: "profit-manager-5f875",
  storageBucket: "profit-manager-5f875.appspot.com",
  messagingSenderId: "983396987987",
  appId: "1:983396987987:web:62e3c91e18dff1aa5c02a6",
  measurementId: "G-3WZRPBD44W"
};

firebase.initializeApp(firebaseConfig);

let app;
firebase.auth().onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app')
  }
})